import React from 'react';
export function Footer() {
  return <footer className="bg-white border-t border-gray-200 py-4 mt-8" data-id="element-205">
      <div className="container mx-auto px-4 md:px-6 max-w-6xl" data-id="element-206">
        <div className="text-center text-sm text-gray-500" data-id="element-207">
          <p data-id="element-208">© 2023. All rights reserved KODIF</p>
        </div>
      </div>
    </footer>;
}